// @flow
import React from 'react';
import type {CryptocurrencyProtocol} from '@tectonics/commons/cryptocurrency/protocol/cryptocurrency-protocol-type';
import Trc20Icon from './trc20-icon';

export const trc20: CryptocurrencyProtocol = {
  code: 'TRC20',
  icon: <Trc20Icon alt="trc20 icon"/>,
  name: 'Tron (TRC-20)',
  abbreviation: 'TRC-20',
};
